<template>
	<v-card outlined>
		<v-card-title
			v-text="'Modules'"
			class="justify-center body-1 primary pa-1"
		>			
		</v-card-title>
		<v-card-text>
			<input_table
				:info_table="info_to_table"
				:list_table="list_to_table"				
			></input_table>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				x-small
				color="primary"
				v-text="'Refresh list'"
				@click="refresh"
			></v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
import input_table from '@/components/info/input_table.vue'
	export default{
		name: 'modules',
		components:{
			input_table
		}, // components
		props: [ 'info_module' ],
		data: (vm) => ({
			info_to_table: null,
			headers_modules:[				
				{ text: vm.$ml.get('name') , value: 'name', align: ''},
				// { text: 'module', value: 'module', align: '' }, 
				{ text: 'Enable', value: 'enable', align: '' },
			], // headers
			list_to_table: [
				{
					name: 'Dasboard',
					module: 'dashboard',
					enable: true,
					icon: 'mdi-view-dashboard',
					roles: [1 , 2, 3], 
				},
				{ 	
					name: 'LPR',				
					module: 'lpr',
					enable: true,
				    icon: 'mdi-card-text',		        
				    roles: [1 , 2, 3], 
				    sub_modules: 
			          	[
			          		/*{
				              name: '', // identific
				              sub_module: '', // path
				              title: '', //
				              icon: ''
				            },*/
			            	{
				              name: 'lpr',
				              sub_module: 'dashboard_lpr',
				              title: 'dashboard',
				              icon: 'mdi-post-outline',
				              
				            },
				            {
				              name: 'Reports',
				              sub_module: 'reports', 
				              title: 'reports',
				              icon: 'mdi-file-chart'				              
				            },
				            
				        ]
				},
				{ 
					name: 'NVR',		
					module: 'nvr',					
					enable: true,
					icon: 'mdi-animation-play-outline',
					roles: [1 , 2], 
				},
				{ 
					name: 'Blacklist',		
					module: 'blacklist',				
					enable: true,
					icon:'mdi-file-alert',
					roles: [1 , 2], 
				},
				{ 
					name: 'RFID',		
					module: 'rfid',
					enable: false,
				},
				{ 	
					name: 'FACE',		
					module: 'face',
					enable: false,
				},
				{ 	
					name: 'SAFE ZONE',		
					module: 'safe_zone',
					enable: true,
					icon: 'mdi-vector-square',
					roles: [1 , 2],
					sub_modules: 
						[
							{
								name: 'Safe zone', 
				            	sub_module: 'safe_zone', 
				              	title: 'dashboard' ,
				              	icon: 'mdi-square-circle'
							},
							{
								name: 'sz_contacts',
								sub_module: 'sz_contacts',								
								title: 'contact_list',
								icon: 'mdi-format-list-bulleted-square'
							}
						]
				},
				{ 					
					name: 'TRAFFIC',
					module: 'traffic',
					enable: false,
				},
				{ 					
					name: 'OBJECT',
					module: 'object',
					enable: false,
				},
				{
					name: 'Settings',
					module: 'settings',
					enable: true,
					icon: 'mdi-cog',
					roles: [1 , 2],
					sub_modules: 
						[
							{
				              name: 'User', 
				              sub_module: 'user', 
				              title: 'user' ,
				              icon: 'mdi-account'
				            },
				            {
				            	name: 'Settings',
				            	sub_module: 'settings',
				            	title: 'hosts',
				            	icon: 'mdi-cog'
				            },
				            {
				            	name: 'Integration',
				            	sub_module: 'integration_cloud',
				            	title: 'integration',
				            	icon: 'mdi-vector-intersection'
				            },
				            {
				            	name: 'Category',
				            	sub_module: 'alert_sounds_settings',
				            	title: 'category',
				            	icon: 'mdi-view-list'
				            }
						]
				}

			], // list to table
		}), // data
		created(){
			this.info_to_table = {
				headers: this.headers_modules,
				total: 6,
				options: { itemsPerPage: 30 },
			}
		}, // created

		methods:{
			refresh(){
				this.$EventBus.$emit('render_modules',{
					name: 'render',
				});
				this.$EventBus.$emit('notifications_modal',{
					type: 'updated'
				})
			}
		}, // methods

		mounted(){
			this.$emit('info_from_component', this.list_to_table);
		}, // mounted
	};
</script>